// components
import { ExternalLink } from 'components/Link/ExternalLink';

// utils
import { externalLinkProps } from '../../constants';
import { useTranslationFunction } from 'utils/hooks/use-translations';

interface WebDetailProps {
  email: string;
  website: string;
  isNord: boolean;
}

export function WebDetail({ email, website, isNord }: Readonly<WebDetailProps>) {
  const translate = useTranslationFunction();

  const nordProps = {
    stylingType: 'primary' as const,
    alignByContent: 'left' as const,
    standardFontSize: false,
  };

  return (
    <>
      {email && (
        <ExternalLink
          content={{
            ...externalLinkProps,
            target: `mailto:${email}`,
            text: translate('web20_locator_email'),
            showArrow: true,
          }}
          pure
          {...(isNord && nordProps)}
        />
      )}
      {website && (
        <ExternalLink
          content={{
            ...externalLinkProps,
            target: website,
            text: translate('web20_locator_website'),
            showArrow: true,
          }}
          pure
          {...(isNord && nordProps)}
        />
      )}
    </>
  );
}
